export function loadZohoSalesIQScript(user) {
  // Check if Zoho SalesIQ script is already loaded
  if (document.getElementById('zsiqscript')) {
    return; // The script is already loaded, no need to load it again
  }

  // Create a new script element for Zoho SalesIQ
  var zohoScript = document.createElement('script');
  zohoScript.type = 'text/javascript';
  zohoScript.id = 'zsiqchat';
  zohoScript.defer = true;
  zohoScript.innerHTML = `
      var $zoho=$zoho || {};
    $zoho.salesiq = $zoho.salesiq || {
    widgetcode: "siq5646794e061e7eb48a0645092742466bdbe22a2d3e65c18c63cb748eec5b79d8",
    values: {},
    ready: function () {}
    };
    var d=document;
    var s=d.createElement("script");
    s.type="text/javascript";
    s.id="zsiqscript";
    s.defer=true;
    s.src="https://salesiq.zohopublic.com/widget";
    var t=d.getElementsByTagName("script")[0];
    t.parentNode.insertBefore(s,t);
    $zoho.salesiq.ready=function(){
      $zoho.salesiq.visitor.name("${user?.firstName + ' ' + user?.lastName}");
      $zoho.salesiq.visitor.email("${user?.emailAddress}");
      $zoho.salesiq.visitor.id("${user?.id}");
      $zoho.salesiq.visitor.info({"hmo_id" : "${user?.hmoId}","plan" : "${user?.plan}","source" : "Reliance Care (WEB APP) EG"});
    }
`;

  // Append the script element to the head section
  document.head.appendChild(zohoScript);
}